import React from 'react';
import Infinite from 'react-infinite';

import {ALL_TRIPS_KEY, UPCOMING_KEY} from '@ibibo/myaccount-reducer';

import * as S from './ListingBody.styles';

import BookingCard from './BookingCard/BookingCard';
import NoBookingCard from './NoBookingCard/NoBookingCard';

const ListingBody = ({bookingDetails, activeTab, navigateToMyTripsDetails, navigateToHotels}) => {
  let count = 0;

  return(
    <S.ListingBodyMainWrap>
      <S.ListingBodyOuterWrap>
        <Infinite
          containerHeight={1900}
          elementHeight={260}
          infiniteLoadBeginEdgeOffset={600}
          handleScroll={() => {}} // was required for displaying google ads in pre-allocated slots
          useWindowAsScrollContainer={window ? true : false} // should be set to false for server-side
        >
          {bookingDetails
            .filter(item => {
              if (activeTab === ALL_TRIPS_KEY) {
                return true;
              }
              return (item.trip_type.toLowerCase() === activeTab);
            }).map((bookingDetail, i) =>{
              count++;
              return (<BookingCard key={`bookingCard${i}`} bookingDetail={bookingDetail} navigateToMyTripsDetails={navigateToMyTripsDetails} />);
            })}
        </Infinite>
        {count === 0 && <NoBookingCard showButton={true} tab={activeTab === ALL_TRIPS_KEY ? '' : activeTab} navigateToHotels={navigateToHotels} />}
      </S.ListingBodyOuterWrap>
    </S.ListingBodyMainWrap>
  );
}

export default ListingBody;